var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.725,
    height: 125.726,
    viewBox: "0 0 125.725 125.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "goals_2_",
    "data-name": "goals (2)",
    d: "M125.725,83.817v31.431a10.474,10.474,0,0,1-10.477,10.477H99.532a10.474,10.474,0,0,1-10.477-10.477V83.817A10.474,10.474,0,0,1,99.532,73.34h15.716A10.474,10.474,0,0,1,125.725,83.817Zm-81.2-57.624a13.1,13.1,0,1,0-13.1-13.1A13.094,13.094,0,0,0,44.527,26.193ZM20.954,104.771H10.477a10.477,10.477,0,0,0,0,20.954H20.954a10.477,10.477,0,1,0,0-20.954Zm57.624-5.239v15.716A10.474,10.474,0,0,1,68.1,125.725H52.385a10.474,10.474,0,0,1-10.477-10.477V99.533a10.445,10.445,0,0,1,5.239-9.026V82.361L30.535,76.876,27.12,87.128a10.466,10.466,0,0,1-9.937,7.161H5.239a5.239,5.239,0,1,1,0-10.477H17.177L20.781,73a13.1,13.1,0,0,1-5.176-13.945l4.7-17.539a13.087,13.087,0,0,1,12.74-10.089H57.336a5.224,5.224,0,0,0,2.7-.749l10.6-6.365a5.239,5.239,0,1,1,5.39,8.984L65.419,39.662A15.722,15.722,0,0,1,57.33,41.9H49.394L42.039,69.642l8.382,2.771a10.458,10.458,0,0,1,7.192,9.948v6.69H68.09A10.474,10.474,0,0,1,78.567,99.528Zm15.716-36.67a5.237,5.237,0,0,0,5.239-5.239V31.432L117.579,20.6a5.7,5.7,0,0,0,0-9.78l-13.552-8.13A18.887,18.887,0,0,0,94.3,0,5.337,5.337,0,0,0,89.06,5.239V57.625A5.237,5.237,0,0,0,94.3,62.863Z",
    transform: "translate(0 0)",
    fill: "#153c42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress2);
export default __webpack_public_path__ + "static/media/in_progress2.3dcf0d95f4f3abe3ce0ca617769f8068.svg";
export { ForwardRef as ReactComponent };